import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Registers the SVG icon sets this app actually draws from.
 *
 * Only the namespaces below ship — the Fuse template's `material-twotone`
 * (default set), `mat_outline` and `mat_solid` sprites were removed: they cost
 * 2.3 MB per deploy and had zero `svgIcon` consumers. Material *font* icons
 * (`<mat-icon>account_tree</mat-icon>`) are unaffected — those resolve against
 * the Material Icons webfont loaded in `index.html`, not against a sprite.
 *
 * Adding a `svgIcon="<name>"` with no namespace, or a `mat_*:` namespace, will
 * now render nothing. Use `heroicons_outline:` / `heroicons_solid:` /
 * `heroicons_mini:` / `feather:`, or a Material font ligature.
 */
@Injectable({ providedIn: 'root' })
export class IconsService {
    constructor() {
        const domSanitizer = inject(DomSanitizer);
        const matIconRegistry = inject(MatIconRegistry);

        matIconRegistry.addSvgIconSetInNamespace(
            'feather',
            domSanitizer.bypassSecurityTrustResourceUrl('icons/feather.svg')
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_outline',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/heroicons-outline.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_solid',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/heroicons-solid.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_mini',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/heroicons-mini.svg'
            )
        );
    }
}
